import { Component } from '@angular/core';

@Component({
  selector: 'report-layout',
  standalone: true,
  imports: [],
  templateUrl: './report-layout.component.html',
  styleUrl: './report-layout.component.scss'
})
export class ReportLayoutComponent {

}
